import { Badge } from '@octopus-do/octopus-storybook'
import { FigmaLogo } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useExportAsFigma } from '@/hooks'
import css from './styles.module.css'

export const ExportFigma: React.FC = () => {
  const onClick = useExportAsFigma(true)

  return (
    <div className={css.export_figma} onClick={onClick}>
      <div className={css.icon_wrap}>
        <FigmaLogo className={css.icon} />
      </div>
      <div className={css.text_wrap}>
        <div className={css.title}>Figma</div>
        <div className={css.description}>Generate wireframes</div>
      </div>
      <div className={css.badge}>
        <Badge type="new" size="large" />
      </div>
    </div>
  )
}
